/* ==========================================================================
   HeaderMasterExpedient > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'HeaderMasterExpedient',
    name: 'header-master-expedient',
    init: true,
    start: true
};

module.exports = () => config;
